import React from 'react';
import FieldSelect from './FieldSelect';
import { LAYER_TYPES, layerLabel } from './layerTypes';
import LayerOptions from './LayerOptions';

// One editable overlay layer: a title row (visibility toggle + remove), an
// optional "group by" field for grouped layers, then the type-specific
// options. onPatch merges a partial into the layer (options or group).
export default function LayerRow({
  layer,
  numeric,
  categorical,
  allFields,
  onPatch,
  onToggle,
  onRemove
}) {
  const groupable = (LAYER_TYPES.find((t) => t.type === layer.type) || {}).groupable;
  const name = layerLabel(layer.type);
  return (
    <section className={`map-layer ${layer.visible ? '' : 'is-hidden'}`}>
      <div className="map-layer-header">
        <label className="map-layer-title">
          <input type="checkbox" checked={layer.visible} onChange={onToggle} />
          {name}
        </label>
        <button
          type="button"
          className="map-layer-remove"
          onClick={onRemove}
          title={`Remove ${name} layer`}
          aria-label={`Remove ${name} layer`}
        >
          ×
        </button>
      </div>
      {groupable && (
        <FieldSelect
          label="Group by"
          options={categorical}
          value={layer.group}
          onChange={(v) => onPatch({ group: v })}
        />
      )}
      <LayerOptions layer={layer} numeric={numeric} allFields={allFields} onPatch={onPatch} />
    </section>
  );
}
